import { BaseEntity } from '../base-entity';
import { Dataset } from './dataset';
import { IdentityPrincipal } from './identity-principal';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContext, AuthzContextsActionMap, CrudAction, CrudAllAction } from '@mri-platform/resource-authz';
/// </code-import>

export interface DatasetAccess {
  targetId: string;
  identityPrincipalId: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  periodEnd: Date;
  periodStart: Date;
  tenantKey: string;
  identityPrincipal: IdentityPrincipal;
  target: Dataset;
}

/// <module-code> Place module level code between <module-code> tags
const typeFuncs = BaseEntity.makeStaticTypeFunctions<DatasetAccess>(EntityName.DatasetAccess);
/// </module-code>

export class DatasetAccess extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static readonly propName = typeFuncs.propName;

  static readonly authorization: AuthzContextsActionMap = {
    ...AuthzContextsActionMap.crudFor(EntityName.DatasetAccess),
    [CrudAllAction.Read]: [AuthzContext.readFor(EntityName.Dataset), AuthzContext.readAllFor(EntityName.DatasetAccess)],
    [CrudAction.Update]: [
      AuthzContext.createFor(EntityName.DatasetAccess),
      AuthzContext.deleteFor(EntityName.DatasetAccess)
    ]
  };
  /// </code>
  // Generated code. Do not place code below this line.
}
